<template>
    <div>
        <div class="d-flex align-items-center">
            <label class="label mb-0 mr-2" for="year"><strong>Year</strong></label>
            <select id="year" v-model="year" class="mr-2">
                <option :value="year" v-for="year in years" :key="year">{{ year }}</option>
            </select>
            <label class="label mb-0 mr-2" for="month"><strong>Month</strong></label>
            <select id="month" v-model="month">
                <option :value="null">Without breakdown by month</option>
                <option :value="month.month" v-for="month in months" :key="month.month">{{ month.label }}</option>
            </select>
        </div>
        <div class="loader" v-if="survey == null">
            <i class="fas fa-circle-notch fa-spin"></i> Fetching survey...
        </div>
        <div class="fields border-top mt-3 pt-3" v-if="survey && stats">
            <p class="readable-text">
                Here you can add statistics from printed surveys for the year {{ year }}. If you want to choose a different year use the selector above.
            </p>
            <div
                class="field mb-2"
                v-for="field in renderedFields"
                :key="field.id"
            >
                <p>
                    <strong>{{ field.title }}</strong>
                </p>
                <table class="table-responsive gf-table">
                    <thead>
                        <tr>
                            <th v-for="option in field.answerOptions" :key="option.id">
                                {{ option.value }}
                            </th>
                            <th>Total</th>
                            <th v-if="field.type == 'range'">Average</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-for="option in field.answerOptions" :key="option.id">
                                <input min="0" class="form-control" type="number" v-model="stats[field.id][option.id]"/>
                            </td>
                            <td>
                                <strong>&nbsp;{{ sumStats(stats[field.id]) }}</strong>
                            </td>
                            <td v-if="field.type == 'range'">
                                <strong>&nbsp;{{ averageStats(field, stats[field.id]) }} {{ field.fieldIsOutOfFive && averageStats(field, stats[field.id]) != 'N/A' ? ' / 5' : ''}}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="actions text-right border-top p-3">
            <button class="btn btn-primary" @click="save">Save</button>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import SurveysService from "../../services/surveys-service";
import RecentYearsMixin from '../../mixins/RecentYearsMixin';
export default {
    data() {
        return {
            survey: null,
            stats: null,
            exists: false
        };
    },
    mixins: [RecentYearsMixin],
    computed: {
        actualFields() {
            if (!this.survey) {
                return [];
            }

            return this.survey.fields
                .filter(field => {
                    return field.type !== 'explanation' && field.type != 'text'
                })
        },
        renderedFields() {
            var renderedFields = [...this.actualFields];
            return renderedFields.map(field => {
                    field.fieldIsOutOfFive = this.fieldIsOutOfFive(field);
                    let answerOptions = field.answerOptions.filter((answerOption) => {
                        return ((field.type != "range" || field.isNps || !this.survey.options.outOfFive) ||
                            (field.type == "range" && this.survey.options.outOfFive && (parseInt(answerOption.value) % 2 == 0)))
                    }).map(answerOption => {
                        if (field.fieldIsOutOfFive) {
                            answerOption.value = parseInt(answerOption.value) / 2;
                        }
                        return answerOption;
                    });

                let mappedField = {...field};
                mappedField.answerOptions = answerOptions;
                return mappedField;
            });
        }
    },
    async mounted() {
        this.loadSurveyByWindowId();
    },
    watch: {
        year: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if (this.survey) {
                    this.getSurveyStats();
                }
            }
        },
        month: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if (this.survey) {
                    this.getSurveyStats();
                }
            }
        },
        survey: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.getSurveyStats();
                }
            }
        }
    },
    methods: {
        async loadSurveyByWindowId() {
            let id = window.location.href.split("/").slice(-2)[0];
            this.survey = await SurveysService.get(id);
        },
        async getSurveyStats() {
            const stats = await SurveysService.manualStats(this.survey.id, this.year, this.month);
            if (stats.stats && Object.keys(stats.stats).length > 0) {
                this.exists = true;
                this.stats = this.mapSurveyStats(this.survey,stats.stats);

            } else {
                this.processSurveyStats();
            }
        },
        async save() {
            var status = null;
            if (!this.exists) {
                status = await SurveysService.importStats(this.survey.id, this.stats, this.year, this.month);
            }
            if (this.exists) {
                status = await SurveysService.updateStats(this.survey.id, this.stats, this.year, this.month);
            }
            if (status) {
                swal('Awesome!', `The stats for ${this.year} have been updated!`, "success")
            }
        },
        mapSurveyStats(survey,stats)
        {
            var fieldsAppendable = {};
            [...survey.fields]
                .filter(field => !Object.keys(stats).includes(field.id.toString()) )
                .map(field => {
                    const answerOptions = {...field.answerOptions}
                    const missingOptions = {};
                    Object.values(answerOptions).forEach(option => {
                        missingOptions[option.id] = 0;
                    })

                    fieldsAppendable[field.id] = missingOptions;
                })
            
            return {
                ...stats,
                ...fieldsAppendable,
            };
        },
        sumStats(stats) {
            return Object.values(stats).reduce((a, b) =>
                parseInt(a) + parseInt(b),
            0)
        },
        averageStats(field, stats) {
            if (field.type !== 'range') {
                return 'N/A';
            }

            var total = 0;
            var count = 0;

            for (let option of field.answerOptions) {
                const stat = stats[option.id];
                total += parseInt(stat) * parseInt(option.value);
                count += parseInt(stat);
            }

            if (count == 0) {
                return 'N/A';
            }

            return (total / count).toFixed(2);
        },
        processSurveyStats() {
            let stats = {}
            for (let field of this.actualFields) {
                stats[field.id] = {}
                for (let option of field.answerOptions) {
                    stats[field.id][option.id] = 0;
                }
            }
            this.stats = stats;
        },
        fieldIsOutOfFive(field) {
            return field.type == "range" && !field.isNps && this.survey.options.outOfFive;
        }
    }
};
</script>

<style scoped>
 .fields {
    max-height: 70vh;
    overflow-y: auto;
 }
</style>
